  
const KonfigTracking = (() => {

  // ── KONFIGURATION ─────────────────────────────────────────
  const WP_URL  = 'https://dashboard.mirrored.pro/';
  const API_KEY = 'testkey';
  const KONFIG  = 'Ampelschirm'; // ← pro Kunde anpassen
  const USER_ID = 3;            // ← WP User ID des Kunden

  // ── SESSION STATE ─────────────────────────────────────────
  const SESSION_ID    = 'sess-' + Math.random().toString(36).substr(2, 9);
  const SESSION_START = { time: null };
  let   _endFired     = false; // doppeltes Feuern verhindern

  // ── DEVICE ────────────────────────────────────────────────
  function getDevice() {
    const ua = navigator.userAgent;
    if (/iPhone|iPad|iPod/.test(ua)) return 'ios';
    if (/Android/.test(ua)) return 'android';
    return 'desktop';
  }

  // ── SEND ──────────────────────────────────────────────────
  function send(element_key, event_type, duration_ms = 0, cart_value = 0) {
    const payload = JSON.stringify({
      user_id:      USER_ID,
      konfigurator: KONFIG,
      element_key,
      event_type,
      duration_ms,
      cart_value,
      device:       getDevice(),
      page_url:     window.location.href,
      session_id:   SESSION_ID,
    });

    // fetch primär
    fetch(`${WP_URL}/wp-json/konfig/v1/track`, {
      method:  'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Konfig-Key': API_KEY,
      },
      body: payload,
    }).catch(() => {
      // Fallback: sendBeacon wenn fetch fehlschlägt
      navigator.sendBeacon(
        `${WP_URL}/wp-json/konfig/v1/track`,
        new Blob([payload], { type: 'application/json' })
      );
    });
  }

  // ── END SESSION ───────────────────────────────────────────
  function endSession() {
    // Doppeltes Feuern verhindern
    if (!SESSION_START.time || _endFired) return;
    _endFired = true;

    const duration_ms = Date.now() - SESSION_START.time;
    SESSION_START.time = null;

    const payload = JSON.stringify({
      user_id:      USER_ID,
      konfigurator: KONFIG,
      element_key:  'session:close',
      event_type:   'dwell',
      duration_ms:  duration_ms,
      cart_value:   0,
      device:       getDevice(),
      page_url:     window.location.href,
      session_id:   SESSION_ID,
    });

    // fetch primär
    fetch(`${WP_URL}/wp-json/konfig/v1/track`, {
      method:  'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Konfig-Key': API_KEY,
      },
      body: payload,
    }).catch(() => {
      // Fallback: sendBeacon
      navigator.sendBeacon(
        `${WP_URL}/wp-json/konfig/v1/track`,
        new Blob([payload], { type: 'application/json' })
      );
    });
  }

  // ── INIT ──────────────────────────────────────────────────
  function init() {
    SESSION_START.time = Date.now();
    _endFired          = false; // Reset falls init() erneut aufgerufen wird
    send('session:start', 'click');

    // Methode 1: Tab/Browser schließen, URL wechseln
    window.addEventListener('beforeunload', endSession, { once: true });

    // Methode 2: Tab wechseln, App minimieren (iOS zuverlässig)
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        endSession();
      }
    }, { once: true });
  }

  // ── TRACK CLICK ───────────────────────────────────────────
  function track(category, value, cartValue = 0) {
    const element_key = ['addcart', 'ar:start', 'session:close'].includes(category)
      ? category
      : `${category}:${value}`;
    send(element_key, 'click', 0, cartValue);
  }

  // ── TRACK DWELL ───────────────────────────────────────────
  function trackDwell(category, value, startTime) {
    const ms = Date.now() - startTime;
    if (ms < 500) return; // unter 0.5s ignorieren
    send(`${category}:${value}`, 'dwell', ms);
  }

  // ── EXPORT ────────────────────────────────────────────────
  return { init, track, trackDwell, endSession };

})();
  


(function () {
  var root = document.currentScript
    ? document.currentScript.closest('[data-clx-gallery]')
    : document.querySelector('[data-clx-gallery]');
  if (!root) root = document.querySelector('[data-clx-gallery]');
  if (!root) return;
 
  var dialog  = root.querySelector('[data-dialog]');
  var openBtn = root.querySelector('[data-open]');
  var closeBtn = root.querySelector('[data-close]');
  var index = 0;
 
  /* ── Öffnen ── */
  if (openBtn) openBtn.addEventListener('click', function () {
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', 'open');
    viewer.src="https://mirrored.pro/wp-content/uploads/Gartenzeit/AMPELSCHIRM.glb";
    KonfigTracking.init();
  });
 
  /* ── Schließen ── */
  function closeDialog() {
    if (dialog.open) dialog.close();
    KonfigTracking.endSession();
  }
 
  if (closeBtn) closeBtn.addEventListener('click', closeDialog);
 
  /* FIX: closeModal Button ist INNERHALB der IIFE, damit closeDialog erreichbar ist */
  var closeModalBtn = root.querySelector('#closeModal');
  if (closeModalBtn) closeModalBtn.addEventListener('click', closeDialog);
 
  /* Klick auf Backdrop schließt Dialog */
  dialog.addEventListener('click', function (e) {
    var rect = dialog.getBoundingClientRect();
    var inside = e.clientX >= rect.left && e.clientX <= rect.right
               && e.clientY >= rect.top  && e.clientY <= rect.bottom;
    if (!inside) closeDialog();
  });
 
  /* Tastatur */
  dialog.addEventListener('keydown', function (e) {
    if (e.key === 'Escape'){     closeDialog(); }
    if (e.key === 'ArrowLeft')  index = Math.max(0, index - 1);
    if (e.key === 'ArrowRight') index = index + 1;
  });
 
})();

  
  
  
  
  
  const viewer = document.getElementById('viewer');

  // ── Material Variants ────────────────────────────────────────────────────
  const VARIANT_NAMES = ['Grau', 'Beige']; // ← ggf. anpassen

  viewer.addEventListener('load', () => {
   // console.log('Verfügbare Varianten:', viewer.availableVariants);
    //applyVariant(0);
  });

  function applyVariant(index) {
    const name = viewer.availableVariants?.[index] ?? VARIANT_NAMES[index] ?? null;
    viewer.variantName = name;
     KonfigTracking.track('Farbe', name);
  }

  function switchVariant(index, btn) {
    document.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    applyVariant(index);
  }

  // ── Animationen ──────────────────────────────────────────────────────────
  // Dauer in Millisekunden pro Animation – hier anpassen:
  const ANIM_DURATIONS = {
    'Hebel Action':    6660,
    '360 RotationAction': 7500,
    "DownN'UpAction":  7500,
  };

  let activeTimer = null;

  function resetAnimState() {
    document.querySelectorAll('.anim-btn').forEach(b => b.classList.remove('active'));
  
    activeTimer = null;
  }

  function playAnimation(name, btn) {
    // Stoppe laufenden Timer und Animation
    if (activeTimer !== null) {
      clearTimeout(activeTimer);
      viewer.pause();
    }

    // Aktiviere den geklickten Button
    document.querySelectorAll('.anim-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    

    // Starte Animation
    viewer.animationName = name;

    KonfigTracking.track('Animation Start', name);

    viewer.currentTime = 0;
    viewer.play({ repetitions: Infinity });

    // Pausiere nach der definierten Dauer
    const duration = ANIM_DURATIONS[name] ?? 3000;
    activeTimer = setTimeout(() => {
      viewer.pause();
      resetAnimState();
    }, duration);
  }

  function stopAnimation() {
    if (activeTimer !== null) {
      clearTimeout(activeTimer);
    }
    viewer.pause();
    resetAnimState();
  }




    const isMobile = () => window.matchMedia('(max-width: 768px)').matches;

  // ── AR Button (Mobile) ───────────────────────────────────────
  const arBtn = document.getElementById('arLaunchBtn');
  const qrBtn = document.getElementById('qrLaunchBtn');

  // Beim Load: richtigen Button zeigen
  function updateARButtons() {
    if (isMobile()) {
      arBtn.style.display = 'inline-flex';
      qrBtn.style.display = 'none';
    } else {
      arBtn.style.display = 'none';
      qrBtn.style.display = 'inline-flex';
    }
  }
  updateARButtons();
  window.addEventListener('resize', updateARButtons);

  // AR direkt starten
  arBtn.addEventListener('click', () => {
    const viewer = document.getElementById('viewer');
     KonfigTracking.track('ar:start', 'ar:start');
    viewer.activateAR();
  });

  // ── QR Modal (Desktop) ───────────────────────────────────────
  const qrModal  = document.getElementById('qrModal');
  const qrClose  = document.getElementById('qrModalClose');

  qrBtn.addEventListener('click', () => {
    qrModal.classList.add('open');
     KonfigTracking.track('ar:start', 'ar:start');
  });
  qrClose.addEventListener('click', () => {
    qrModal.classList.remove('open');
  });
  qrModal.addEventListener('click', (e) => {
    if (e.target === qrModal) qrModal.classList.remove('open');
  });